<template>
  <div class="stm-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I ∝ e^(-2κd) | 原子级成像$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Sample (Atom Surface) -->
          <g transform="translate(50, 200)">
             <circle v-for="i in 10" :key="i" :cx="i*30" :cy="Math.sin(i+time)*5" r="12" fill="rgba(0, 210, 255, 0.4)" stroke="#00d2ff" />
             <text x="100" y="35" fill="#888" font-size="8">样品原子表面</text>
          </g>

          <!-- The Scanning Tip -->
          <g :transform="`translate(${tipX}, ${tipY})`">
             <path d="M -20,-80 L 0,0 L 20,-80 Z" fill="#aaa" stroke="#fff" />
             <circle r="3" fill="#ff4757" />
             <text x="5" y="-30" fill="#fff" font-size="8">单原子针尖</text>
             
             <!-- Tunneling electrons -->
             <g v-if="isScanning">
                <circle v-for="n in 5" :key="n" r="1.5" fill="#fff">
                   <animate attributeName="cy" from="0" to="20" :dur="`${0.5 + Math.random()}s`" repeatCount="indefinite" />
                </circle>
             </g>
          </g>

          <!-- The Topo Graph -->
          <rect x="250" y="40" width="120" height="80" fill="#111" stroke="#2ed573" />
          <path :d="topoPath" fill="none" stroke="#2ed573" stroke-width="2" />
          <text x="255" y="35" fill="#2ed573" font-size="8">原子形貌图</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>隧道电流 I: {{ (100/tipY).toFixed(2) }} nA</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="startScan">执行原子级扫描</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>STM利用了量子力学中的**势垒隧道效应**。当一个极细的金属圆针尖靠近样品表面（距离小于1纳米）时，即使针尖与表面不接触，电子也会因为“波动性”而穿过势垒产生微弱电流。由于电流随距离呈指数级剧烈变化，通过维持电流恒定并移动针尖，电脑就能绘制出单个原子的具体排列图案。这是纳米技术研究的关键工具。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'STMImagingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tipX: 100,
      tipY: 150,
      time: 0,
      isScanning: false,
      topoPoints: []
    }
  },
  computed: {
    topoPath() {
       let d = "M 250,120 ";
       this.topoPoints.forEach((p, idx) => {
          d += `L ${250 + idx*2} ${120 - p} `;
       });
       return d;
    }
  },
  methods: {
    startScan() {
       this.isScanning = true;
       this.topoPoints = [];
       let count = 0;
       const run = () => {
          if (count > 60) {
             this.isScanning = false;
             return;
          }
          this.tipX = 100 + count * 3;
          // Follow atom contour
          this.tipY = 175 + Math.sin(this.tipX / 30 * 3.14) * 8;
          this.topoPoints.push(185 - this.tipY);
          count++;
          requestAnimationFrame(run);
       };
       run();
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.stm-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
